var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFoodIconcomponent = function SvgFoodIconcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 6.75h1.5V1.5h1.5v5.25a3 3 0 0 1-3 3v6.75h-1.5V9.75a3 3 0 0 1-3-3V1.5h1.5v5.25h1.5V1.5h1.5v5.25ZM12 10.5v-6c0-1.32 1.68-3 3.75-3v15h-1.5v-6H12Z",
    fill: "#CECCC9"
  })));
};
export default SvgFoodIconcomponent;